import { CustomPlayerEvent, ImaEvent } from 'types/player';
import AbstractPlayerEventConsumer from 'components/pages/playback/player-event-consumers/AbstractPlayerEventConsumer';

export default class LightningPlayerEventConsumer extends AbstractPlayerEventConsumer {
  $videoPlayerEvent(type: string, event: any, ...args: any) {
    switch (type) {
      case CustomPlayerEvent.SEEK_PAUSE: {
        this.signal('$videoManagerSeekPause', event, ...args);
        break;
      }
      case CustomPlayerEvent.BEFORE_SEEK: {
        this.signal('$videoManagerBeforeSeek', event, ...args);
        break;
      }
      // Ad pod start
      case ImaEvent.AD_BREAK_STARTED: {
        this.signal('$videoManagerAdBreakStarted', event, ...args);
        break;
      }
      // Ad segment start
      case ImaEvent.STARTED: {
        this.signal('$videoManagerStarted', event, ...args);
        break;
      }
      // Ad segment end
      case ImaEvent.COMPLETE: {
        this.signal('$videoManagerComplete', event, ...args);
        break;
      }
      case CustomPlayerEvent.SKIP_AD_POD: // Skipping ad pod that has already been watched
        this.signal('$videoManagerSkipAdPod', type, event, ...args);
        break;
      case CustomPlayerEvent.CLEANUP_AD_POD: // AD_BREAK_END is never called despite finishing ad
        this.signal('$videoManagerCleanupAdPod', type, event, ...args);
        break;
      case ImaEvent.AD_BREAK_ENDED: // Ad pod end
        this.signal('$videoManagerAdBreakEnded', type, event, ...args);
        break;
      case CustomPlayerEvent.UNLOADING:
        this.signal('$videoPlayerUnloading', type, event, ...args);
        break;
      default:
        this.signal('$videoPlayerEvent', type, event, ...args);
        break;
    }
  }
}
